
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/coupons",
      function () {
        return require("private-next-pages/[publicId]/coupons/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/coupons"])
      });
    }
  